<template lang="pug">
  .container
    .header
      img.banner(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/ningxia/header2.jpeg")
      el-form.mobile-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入宁夏移动手机号")
        el-form-item(v-if="isCheckMobile")
          el-row
            el-col(:span="13")
              el-input(type="text", placeholder="请输入短信验证码", v-model="form.verifyCode", maxlength="6")
            el-col(:span="9", :offset="1")
              el-button(type="warning", :disabled="leftSendTime > 0", @click="sendVerifyCode")
                span(v-if="leftSendTime <= 0") 获取验证码
                span(v-else) {{leftSendTime}}秒后可重试
        el-form-item.btn-submit
          el-button(v-if="!isCheckMobile", type="warning", @click="checkMobile") 限时领取
          el-button(v-else, type="warning", @click="showConfirm") 确定办理
        el-form-item.protocol
          el-checkbox(v-model="agreeProtocol") 我已同意并阅读
          el-link(type="primary", @click="protocolVisiable = true") 《协议内容》
    .notice.page-inner
      ul
        li(v-for="(notice, index) in notices", :key="index")
          .num {{index + 1}}.
          p.content {{notice}}
    el-dialog(
      width="80%",
      title="提示",
      :visible.sync="dialogVisible",
      :before-close="handleClose"
    )
      .dialog-content
        div
          | 您要为手机号：
          span.mobile-info {{form.mobile}}
        div
          | 办理业务：
          span.package-info {{selectedPackage.confirmInfo}}
      span.dialog-footer(slot="footer")
        el-button(@click="dialogVisible = false") 取消
        el-button(type="primary", @click="handleSubmit") 确定
    el-dialog(width="90%", title="协议内容", :visible.sync="protocolVisiable")
      .notice
        ul
          li(v-for="(notice, index) in notices", :key="index")
            .num {{index + 1}}.
            p.content {{notice}}
</template>

<script>

// 推啊=TUIA、豆盟=DOUMENG、快手=KUAISHOU
export default {
  data() {
    return {
      errlog: '',
      shareNoticeVisiable: false,
      dialogVisible: false,
      leftSendTime: 0,
      isCheckMobile: false,
      channel: 'TUIA',
      protocolVisiable: false,
      agreeProtocol: false,
      form: {
        carrierId: 3,
        mobile: '',
        verifyCode: '',
        userId: null,
        sharerId: null
      },
      notices: [
        '资费说明：24.9元/月，订购首月免费（扣费24.9元后即时返还等额话费），次月正常收费。',
        '产品说明：本产品包含20GB定向流量+视频会员6选一，20GB定向流量为爱奇艺、优酷视频、腾讯视频、咪咕视频、芒果TV、PPTV视频、快手、抖音APP定向流量，视频会员为爱奇艺、优酷视频、腾讯视频、咪咕视频、芒果TV、PPTV视频月卡会员任选一',
        '合约说明：本产品为连续包月产品，订购成功后立即生效。订购首月不可退订，第二个月可退订。如退订，退订次月1日生效，订购后不可回退。',
        '流量说明：20GB定向流量优先级高于主套餐、流量可选包，产品内所含流量不可结转，不可转赠，不可分享，当月月底失效。',
        'VIP权益说明：客户办理成功之后且不退订业务，即可每月领取一次会员权益，客户需主动关注微信公众号“冰蓝流量”输入“宁夏移动”进入权益领取界面领取，权益自选择之日起，30个自然日内有效，各大权益平台有效期不相同，以实际权益提供方显示有效期为准。若用户退订了本业务，则次月不再享有视频会员领取资格。',
        '本产品最终解释权归宁夏移动所有，如有疑问详询10086。'
      ],
      selectedPackage: {},
      packageList: [
        {
          goodsCode: 'TUIA08260001',
          confirmInfo: '首月免费体验，月费24.9元，并于5个工作日内将24.9元话费返还到账，包含20GB定向流量+视频会员6选一',
        }
      ]
    }
  },
  mounted() {
    this.handleSelected(this.packageList[0])
  },
  methods: {
    handleSelected(selectedPackage) {
      this.selectedPackage = selectedPackage
    },
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    showConfirm() {
      this.dialogVisible = true
    },
    checkMobile() {
      if(!this.agreeProtocol) {
        this.$message({
          type: 'warning',
          message: '请阅读《协议内容》，并勾选'
        })
        return;
      }
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.selectedPackage.goodsCode,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.isCheckMobile = true
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleSubmit() {
      this.dialogVisible = false
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.agreeProtocol) {
        this.$message({
          type: 'warning',
          message: '请阅读《协议内容》，并勾选'
        })
        return;
      }
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.selectedPackage.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() { 
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            this.$router.push({
              name: 'nxSuccess'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scope>
.container{
  background-color: rgb(30, 136, 204);
  padding-bottom: 3.5rem;
}
.header{
  .banner{
    width: 100%;
  }
}
.module-bg{
  width: 90%;
  margin: 0 auto;
  border: 2px solid #48c89f;
  border-radius: 6px;
  padding: 6px;
  background-color: #ffffff;
}
.mobile-form{
  padding: 0 48px;
  margin-top: -186px;
  .btn-submit{
    button{
      width: 100%;
      border-radius: 0;
      font-size: 1.3rem;
      border-radius: 36px;
      box-shadow: 0 3px 3px #a3a3a3;
    }
  }
}
.user-notice{
  margin-top: 12px;
  font-size: .8rem;
  color: #222;
  .title{
    color: #48c89f;
    font-size: 1rem;
  }
  .content{
    text-align: left;
    margin: 6px;
    ul{
      margin-left: .4rem;
    }
  }
}
.dialog-content{
  text-align: left;
  .mobile-info{
    color: #333;
    font-weight: bold;
  }
  .package-info{
    color: #e75e25;
    font-weight: bold;
  }
}
.share-ad{
  text-align: center;
  color: #a3a3a3;
  font-size: .9rem;
  img{
    width: 94%;
  }
}
.share-dialog{
  position: fixed;
  z-index: 10;
  top: 0px;
  right: 0px;
  background-color: rgba(0,0,0,.8);
  width: 100%;
  height: 900px;
}
.protocol{
  text-align: center;
  *{
    font-size: 14px;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #333;
  }
  .el-form-item__content{
    line-height: 30px;
  }
}
.share-infos{
  color: #a3a3a3;
  font-size: .5rem;
}
.img-desc{
  margin: 0 1.2rem;
  margin-top: 2.6rem;
  img{
    width: 100%;
  }
}
.notice{
  position: relative;
  &.page-inner:after{
    position: absolute;
    background: url('../../../public/images/ningxia/title.png') no-repeat;
    background-size: 100%;
    content: '';
    width: 14rem;
    height: 4rem;
    left: 50%;
    top: -.8rem;
    margin-left: -7rem;
  }
  background-color: #fff;
  border-radius: .4rem;
  text-align: left;
  font: "黑体", "Arial";
  &.page-inner{
    padding: 1.5rem .8rem .6rem;
    margin: 0 1.2rem;
    margin-top: 5rem;
    color: rgb(30, 136, 204);
    ul{
      margin-top: 1rem;
    }
  }
  ul{
    li{
      clear: both;
      overflow: hidden;
      font-size: .9rem;
      margin-bottom: .2rem;
      .num{
        float: left;
        width: 1.4rem;
        line-height: 1.5rem;
      }
      .content{
        line-height: 1.5rem;
        margin-left: 1.3rem;
      }
    }
  }
}
.el-form-item {
  margin-bottom: .4rem;
}
</style>